import { Draft, produce } from 'immer';

import { UI_BULK_REQUEST__SET_PREVIEW_TASK_ID } from '@app/store/actionTypes';
import { UIBulkRequestAction } from '@app/store/ui/bulk-request/actions';

export interface UIBulkRequestState {
  previewTaskId: string | null;
}

const initialState: UIBulkRequestState = {
  previewTaskId: null,
};

const reducer = produce((draft: Draft<UIBulkRequestState>, action: UIBulkRequestAction) => {
  switch (action.type) {
    case UI_BULK_REQUEST__SET_PREVIEW_TASK_ID: {
      draft.previewTaskId = action.payload;
      break;
    }
    default:
      break;
  }
}, initialState);

export default reducer;
